import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=46e56d97"
import script from "@/services/assignment/assignment-list.js?vue&type=script&lang=js&external"
export * from "@/services/assignment/assignment-list.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports